export default function sortOrderItemsBySkuNumber(orderItems: Array<any>) {
    return orderItems.sort((a, b) => {
        if (a.skuNumber < b.skuNumber) {
            return -1;
        }
        if (a.skuNumber > b.skuNumber) {
            return 1;
        }
        return 0;
    });
}
